import { FREE_LIMIT } from '../hooks/useAILimit';

export default function AILimitBanner({ remaining, onUpgrade }) {
  if (remaining === Infinity) return null; // Pro user — show nothing

  const isLow     = remaining <= 1;
  const isExhausted = remaining === 0;

  if (!isLow && !isExhausted) return null; // Still has plenty — no banner

  return (
    <div style={{
      background: isExhausted
        ? 'rgba(239,68,68,0.15)'
        : 'rgba(251,191,36,0.12)',
      border: `1px solid ${isExhausted
        ? 'rgba(239,68,68,0.4)'
        : 'rgba(251,191,36,0.3)'}`,
      borderRadius: 12, padding: '10px 14px',
      marginBottom: 12,
      display: 'flex', justifyContent: 'space-between',
      alignItems: 'center', gap: 12,
    }}>
      <span style={{ fontSize: 13, color: isExhausted ? '#fca5a5' : '#fbbf24' }}>
        {isExhausted
          ? `🚫 Daily AI limit reached (${FREE_LIMIT}/day on free plan)`
          : `⚠️ ${remaining} AI lookup${remaining === 1 ? '' : 's'} remaining today`}
      </span>
      <button onClick={onUpgrade} style={{
        padding: '6px 12px', borderRadius: 8, border: 'none',
        background: isExhausted
          ? 'linear-gradient(135deg, #5282ff, #a855f7)'
          : 'rgba(251,191,36,0.2)',
        color: isExhausted ? '#fff' : '#fbbf24',
        fontSize: 12, fontWeight: 700, cursor: 'pointer',
        whiteSpace: 'nowrap',
      }}>
        Upgrade ⭐
      </button>
    </div>
  );
}